// let volatileToken;
export default {
    getUserInfo() {
        return JSON.parse(localStorage.profile || "{}");
    },
    
    /*
    registerVolatileToken(token) {
        volatileToken = token;
    },
    getVolatileToken() {
        return volatileToken;
    },
    destroyVolatileToken() {
        volatileToken = undefined;
    },
    */
    registerSessionToken(token) {
        sessionStorage.token = token;
    },
    getSessionToken() {
        return sessionStorage.token || "";
    },
    destroySessionToken() {
        delete sessionStorage.token;
    },

    isToken() {
        // Tokenized
        // return !!localStorage.token;
        // Volatile
        // return !!volatileToken;
        // Session
        return !!sessionStorage.token
    },
    isLogged(options) {
        if(!this.isToken()) {
            options.onNoToken(false);
        }
        options.onSuccess(true);
    },
    login(options) {
        let user = "admin";
        let token = "asd!!sfd-";

        localStorage.user = user;
        localStorage.token = token;
        
        options.onSuccess({
            user: user,
            token: token
        })
    },
    logout() {
        delete localStorage.token;
    }
}


// WEBPACK FOOTER //
// ./src/utils/authUtil.js